<template>
    <div ref="xinlv"></div>
</template>

<script>

import * as echarts from 'echarts';

export default {
    name: "HealthXueYaChart",
    data() {
        return {
            loading: false
        }
    },
    props: {
        values: {
            type: [String, Array],
            default: ''
        }
    },
    computed: {},
    mounted() {
        this.drawLine()
    },
    methods: {
        drawLine() {
            let _this = this
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(this.$refs.xinlv)
            // 绘制图表
            myChart.setOption({
                // Make gradient line here
                backgroundColor: ['#0e2f6e00'], // 全图默认背景
                color: ['#19c9fe'],
                grid: {
                    bottom: '0px',
                    top: '0px'
                },
                // 提示框组件
                tooltip: {
                    trigger: 'item',     // 触发类型
                    triggerOn: 'mousemove',  // 出发条件
                    formatter(params) {
                        const item = _this.values[params.dataIndex]
                        return `${item.create_time}<br>高压${item.Shrink}<br>低压${item.Diastolic}`
                    },
                },
                xAxis: {
                    data: this.values.map(item => {
                        return item.create_time
                    }),
                    axisLine: false,
                    show: false,
                    splitLine: {
                        interval: 0,
                        show: false, // x轴、y轴显示网格线,坐标轴在 grid 区域中的分隔线
                        lineStyle: {
                            // 使用深浅的间隔色--分隔线颜色，可以设置成单个颜色。也可以设置成颜色数组，分隔线会按数组中颜色的顺序依次循环设置颜色。
                            color: '#ffffff11'
                        }
                    }
                },
                yAxis: {
                    max: 180,
                    min: -120,
                    type: 'value',
                    axisLine: false,
                    show: false, // x轴、y轴显示网格线,坐标轴在 grid 区域中的分隔线
                    splitLine: {
                        show: false, // x轴、y轴显示网格线,坐标轴在 grid 区域中的分隔线
                        lineStyle: {
                            // 使用深浅的间隔色--分隔线颜色，可以设置成单个颜色。也可以设置成颜色数组，分隔线会按数组中颜色的顺序依次循环设置颜色。
                            color: '#ffffff11'
                        }
                    }
                },
                // 系列列表。每个系列通过 type 决定自己的图表类型
                series: [{
                    type: 'bar', // 线条
                    barWidth: 7,
                    showBackground: true,
                    backgroundStyle: {
                        color: '#ffffff11'
                    },
                    stack: '血压',
                    showSymbol: false, // 是否显示 symbol符号, 如果 false 则只有在 tooltip hover 的时候显示。
                    data: this.values.map(item => {
                        return -item.Diastolic
                    })
                }, {
                    type: 'bar', // 线条
                    barWidth: 7,
                    showBackground: true,
                    backgroundStyle: {
                        color: '#ffffff11'
                    },
                    itemStyle: {
                        color:'#19c9fe',
                    },
                    stack: '血压',
                    showSymbol: false, // 是否显示 symbol符号, 如果 false 则只有在 tooltip hover 的时候显示。
                    data: this.values.map(item => {
                        return item.Shrink
                    })
                }]
            });
        }
    },
    watch: {
        values(){
            this.drawLine()
        }
    },
    filters: {}
}
</script>

<style scoped lang="scss">

</style>